import { FC, useContext, useRef, useState} from "react"
import { AgGridColumn, AgGridReact} from "ag-grid-react"
import '../../../../../ag-grid.css'
import '../../../../../ag-theme-alpine.css'
import './pajeratable.css'
import { warning } from "../../../../../utils/notifications"
import { GiPlantRoots, GiWoodPile } from "react-icons/gi"
import {  EditModalNumberDialog } from "./EditModalNumberDialog/EditModalNumberDialog"
import { EDIT_TYPES } from "../../../../../data/constants"
import {  diferencialEuroRenderer, diferencialKmRenderer, numberFormatter } from "../../../../../utils/helperFunctions"
import moment from "moment"
import { UserContext } from "../../../../../Redux/UserContext"


export const PajeraTable:FC<any> = (props):JSX.Element => {

    const { data, dataMASTER, setData, simulated,original, saveLoading, same, scenarioBase,dataPlanificacion } = props

    const [state] = useContext(UserContext)

    const [ type, setType ] = useState<number>(0)

    const [ visible, setVisible ] = useState<boolean>(false)

    const [ selectedCell, setSelectedCell ] = useState<any>()

    const [ selectedRow, setSelectedRow ] = useState<any>()

    const [ mode, setMode] = useState<string>("")

    const handleClose = () => {
        setSelectedCell(undefined)
        setSelectedRow(undefined)
        setVisible(false)
        setMode("")
    }

    const gridRef :any= useRef();



    const booleanRenderer = (params:any) => {
        if(params.value === true) {
            return '✔️'
        }
        return '❌'
        
    }

    const stockRenderer = (params: any) => {
        let { colId } = params.column
    
        if (params.value) {
            const currentDate = new Date(); // Puedes cambiar esto para obtener la fecha actual de forma dinámica si es necesario
    
            let selectedValues = [];
    
            // Filtrar los objetos que coinciden con el mes y año actual
            selectedValues = params.value.filter((item: any) => {
                const itemDate = new Date(`${item.anio} ${item.mes}`);
                return currentDate.getMonth() === itemDate.getMonth() && currentDate.getFullYear() === itemDate.getFullYear();
            });
    
            // Si no hay coincidencias, seleccionar los dos últimos elementos
            if (selectedValues.length === 0) {
                selectedValues = params.value.slice(-2);
            }
            if(colId === 'precio_material_a' || colId === 'precio_material_b') {
                if (selectedValues.length > 1) {
                    return `${numberFormatter(selectedValues[0]?.precio)}/${numberFormatter(selectedValues[1]?.precio)}`;
                } else if (selectedValues.length === 1) {
                    return numberFormatter(selectedValues[0]?.precio);
                }
            } else {
                if (selectedValues.length > 1) {
                    return `${numberFormatter(selectedValues[0]?.cantidad)}/${numberFormatter(selectedValues[1]?.cantidad)}`;
                } else if (selectedValues.length === 1) {
                    return numberFormatter(selectedValues[0]?.cantidad);
                }
            }
            
        }
    
        return '';
    };

    const fuelTypeRenderer = (params:any) => {
        if(params.value === 1) {
            return <GiPlantRoots size={20} />
        }
        return <GiWoodPile size={20} />
    }

    const handleEditCellContent = (params:any) => {
        let { colId } = params.column
        if(colId !== 'name_warehouse' && colId !== 'tipo_combustible_a' && colId !== 'tipo_combustible_b' && colId !== 'nombre_proveedor_a' && colId !== 'nombre_proveedor_b' && colId !== 'zona_precipitacion_a' && colId !== 'zona_precipitacion_b' && colId !== 'precio_alquiler_acopio_a' && colId !== 'precio_alquiler_acopio_b' && colId !== 'precio_material_a' && colId !== 'precio_material_b' ) {
            switch(colId) {
                case 'tipo_combustible_a':
                case 'tipo_combustible_b':
                    setType(EDIT_TYPES.icon)
                    break;
                case 'acopio_techado_a':
                case 'acopio_techado_b':
                    setType(EDIT_TYPES.boolean)
                    break;
                case 'nombre_proveedor_a':
                case 'nombre_proveedor_b':
                    setType(EDIT_TYPES.autocomplete)
                    break;
                case 'stock_inicial_a':
                case 'stock_inicial_b':
                    setType(EDIT_TYPES.object)
                    break;
                case 'fecha_retirada_a':
                case 'fecha_retirada_b':
                    setType(EDIT_TYPES.date)
                    break;
                default:
                    setType(EDIT_TYPES.number)
                
            }
            let modo = colId.split("_")
            modo.slice(-1)[0] === 'a'? setMode("base") : setMode("comparision")
            if(modo.slice(-1)[0] === 'a') {
                if(simulated.scenario_base && !original.scenario_base && colId !== 'stock_inicial_a') {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_base && colId !== 'precio_material_a' && colId !== 'stock_inicial_a') {
                    warning("No se puede editar en el escenario original.")
                } else if(original.scenario_base) {
                    warning("No se puede editar el escenario original.")
                } else if(same) {
                    warning('Estás tratando de editar los parámetros del mismo escenario. Sal del modo "comparación" para poder editarlo.')
                } else {
                    if(colId !== 'nombre_proveedor_a' && colId !== 'nombre_proveedor_b') {
                        setSelectedCell(colId)
                        setSelectedRow(params.data)
                        setVisible(true)
                    }
                }
            } else {
                if(simulated.scenario_comparision && !original.scenario_comparision && colId !== 'stock_inicial_b') {
                    warning("No se puede editar un escenario que ya está simulado.")
                } else if(original.scenario_comparision && colId !== 'precio_material_b' && colId !== 'stock_inicial_b') {
                    warning("No se puede editar en el escenario original.")
                } else if(original.scenario_comparision) {
                    warning("No se puede editar el escenario original.")
                } else if(same) {
                    warning('Estás tratando de editar los parámetros del mismo escenario. Sal del modo "comparación" para poder editarlo.')
                } else {
                    if(colId !== 'nombre_proveedor_a' && colId !== 'nombre_proveedor_b') {
                        setSelectedCell(colId)
                        setSelectedRow(params.data)
                        setVisible(true)
                    }
                    
                }
            }
        }

        
        
    }

    const handleCellStyleEditable = (params:any) => {
        let original = dataMASTER.find((ori:any) => ori.id_warehouse === params.data.id_warehouse)?.[params.column.colId]
        if(original != params.value) {
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',height:'100%',border:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',height:'100%',border:'1px solid #dee2e6'}
        }   
    }

    const handleCellStyle = (params:any) => {
        let original = dataMASTER.find((ori:any) => ori.id_warehouse === params.data.id_warehouse)?.[params.column.colId]
       
        if(original != params.value) {
            
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',borderRight:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'rgb(236, 236, 236)',color: 'black',fontWeight:'normal',borderRight:'1px solid #dee2e6'}
        } 
    }

    
    


    return (
        <div className="pajeratable__wrapper">
            <EditModalNumberDialog
                simulated={simulated}
                original={original}
                visible={visible}
                setVisible={setVisible}
                handleClose={handleClose}
                selectedCell={selectedCell}
                setSelectedCell={setSelectedCell}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                mode={mode}
                setMode={setMode}
                data={data}
                dataMASTER={dataMASTER}
                setData={setData}
                type={type}  
                scenario={scenarioBase}
                dataPlanificacion={dataPlanificacion}
            />

            <div className="ag-theme-alpine" style={saveLoading? {display:'flex',flexDirection:'column', height:'100%', width: '100%',opacity:0.6 } : {display:'flex',flexDirection:'column', height:'100%', width: '100%' }}>
            {
                    saveLoading?
                        <div className="scenario__overlay-table"></div>
                        :
                        false
                }
                <div className="contrato_back_btn">
                    <span><b> </b></span>
                </div>
                <AgGridReact
                    ref={gridRef}
                    headerHeight={30}
                    getRowHeight={() => 30}
                    onCellDoubleClicked={state?.rol_id !== undefined? [3,4].includes(state.rol_id) && !state.id_plants.includes(scenarioBase.id_plant) ? () => warning("No tienes permisos para realizar esta acción") : handleEditCellContent : () => warning("No tienes permisos para realizar esta acción")}
                    rowData={data}
                    enableCellTextSelection
                    >
                    <AgGridColumn sort={'desc'}  resizable={true}  hide  field={"id"}></AgGridColumn>
                    <AgGridColumn sortable    suppressNavigable={true} hide   headerName={"Almacén"} field={"id_warehouse"}></AgGridColumn>

                    <AgGridColumn cellStyle={handleCellStyle} headerClass={"header-border header-resize"} sortable filter={true}  maxWidth={180} suppressNavigable={true} tooltipField={"name_warehouse"}   headerName={"Almacén"} field={"name_warehouse"}></AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Tipo de combustible" maxWidth={180}  >
                        <AgGridColumn cellStyle={handleCellStyle} sortable headerClass={"var(--lis-dark)-column header-resize"} cellRenderer={fuelTypeRenderer} maxWidth={90} suppressNavigable  headerName="Esc A" field="tipo_combustible_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyle}  sortable headerClass={"var(--lis-alternative)-column header-resize"} cellRenderer={fuelTypeRenderer} maxWidth={90} suppressNavigable   headerName="Esc B" field="tipo_combustible_b"></AgGridColumn>
                    </AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Propietario" maxWidth={380} >
                        <AgGridColumn cellStyle={handleCellStyle}  sortable headerClass={"var(--lis-dark)-column header-resize"} maxWidth={190} suppressNavigable tooltipField="nombre_proveedor_a"     headerName="Esc A" field="nombre_proveedor_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyle}  sortable headerClass={"var(--lis-alternative)-column header-resize"} maxWidth={190} suppressNavigable tooltipField="nombre_proveedor_b"       headerName="Esc B" field="nombre_proveedor_b"></AgGridColumn>
                    </AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Zona de precipitación" maxWidth={180} >
                        <AgGridColumn cellStyle={handleCellStyle}  sortable headerClass={"var(--lis-dark)-column header-resize"} maxWidth={90} suppressNavigable    headerName="Esc A" field="nombre_zona_precipitacion_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyle}  sortable headerClass={"var(--lis-alternative)-column header-resize"} maxWidth={90} suppressNavigable    headerName="Esc B" field="nombre_zona_precipitacion_b"></AgGridColumn>
                    </AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Distancia a planta" maxWidth={200} >
                        <AgGridColumn cellStyle={handleCellStyleEditable}  sortable headerClass={"var(--lis-dark)-column header-resize"} cellRenderer={diferencialKmRenderer} maxWidth={100} suppressNavigable  headerName="Esc A" field="distancia_planta_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyleEditable}  sortable headerClass={"var(--lis-alternative)-column header-resize"} cellRenderer={diferencialKmRenderer}  maxWidth={100} suppressNavigable  headerName="Esc B" field="distancia_planta_b"></AgGridColumn>
                    </AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Techado" maxWidth={170} >
                        <AgGridColumn cellStyle={handleCellStyleEditable}  sortable headerClass={"var(--lis-dark)-column header-resize"} maxWidth={85} suppressNavigable  cellRenderer={booleanRenderer}  headerName="Esc A" field="acopio_techado_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyleEditable}  sortable headerClass={"var(--lis-alternative)-column header-resize"} maxWidth={85} suppressNavigable   cellRenderer={booleanRenderer}  headerName="Esc B" field="acopio_techado_b"></AgGridColumn>
                    </AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Precio de alquiler del acopio" maxWidth={200} >
                        <AgGridColumn cellStyle={handleCellStyle}  sortable headerClass={"var(--lis-dark)-column header-resize"} maxWidth={100} suppressNavigable cellRenderer={diferencialEuroRenderer}  headerName="Esc A" field="precio_alquiler_acopio_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyle}  sortable headerClass={"var(--lis-alternative)-column header-resize"} maxWidth={100} suppressNavigable  cellRenderer={diferencialEuroRenderer}  headerName="Esc B" field="precio_alquiler_acopio_b"></AgGridColumn>
                    </AgGridColumn>
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Stock inicial" maxWidth={180} >
                        <AgGridColumn cellStyle={handleCellStyleEditable}  sortable headerClass={"var(--lis-dark)-column header-resize"} maxWidth={90} suppressNavigable  cellRenderer={stockRenderer}  headerName="Esc A" field="stock_inicial_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyleEditable}  sortable headerClass={"var(--lis-alternative)-column header-resize"} maxWidth={90} suppressNavigable   cellRenderer={stockRenderer}  headerName="Esc B" field="stock_inicial_b"></AgGridColumn>
                    </AgGridColumn>
                    
                    <AgGridColumn headerClass={"header-border-left header-resize"} headerName="Precio del material" maxWidth={190} >
                        <AgGridColumn cellStyle={handleCellStyle}  sortable headerClass={"var(--lis-dark)-column header-resize"} maxWidth={95} suppressNavigable cellRenderer={stockRenderer} headerName="Esc A" field="precio_material_a"></AgGridColumn>
                        <AgGridColumn cellStyle={handleCellStyle}  sortable headerClass={"var(--lis-alternative)-column header-resize"} maxWidth={95}  suppressNavigable cellRenderer={stockRenderer}   headerName="Esc B" field="precio_material_b"></AgGridColumn>
                    </AgGridColumn>

                </AgGridReact>
            </div>
            
        </div>
        
    )
}